import {useSelector} from "react-redux";
import {parseISO} from "date-fns";

import {IRPStore} from "../../../app/rp_reducer";
import {ALL_ROOMS} from "../constants/rcn_rooms_filter";
import {calculateGeneralAvgPrices} from "./calculate_general_avg_prices";
import {getAvgPriceM2ForRooms} from "./get_avg_price_m2_for_rooms";
import {getCitiesData} from "./get_cities_data";
import {getLatestPriceReport} from "./get_latest_price_report";
import {calculatePercent} from "./percents_handling_helpers";

export const usePricesHeaderData = (region?: string) => {
    const pricesData = useSelector((state: IRPStore) => state.report.price.prices);

    if (region && pricesData) {
        const lastMonthData = getLatestPriceReport(pricesData);

        // A failed BigData call resolves to an empty array - without this guard the city view dereferences
        // undefined and the whole page dies in renderToString.
        if (!lastMonthData) {
            return {dateLabel: undefined, dataToRender: null};
        }

        const date = parseISO(lastMonthData.date);
        const month = date.toLocaleString("pl-PL", {month: "long"});
        const dateLabel = `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

        // No year-ago comparison is fetched for city/district views - none of their consumers (Hero/
        // Calculator) read percent or median_price_m2, only avr_price_m2.price.
        const dataToRender = {
            // Same source and same "all rooms" resolution as PricesDifferences's "Aktualna cena ofertowa"
            // card, so the two stay in sync by construction instead of by coincidence.
            avr_price_m2: {price: getAvgPriceM2ForRooms(lastMonthData, ALL_ROOMS)},
            median_price_m2: {price: lastMonthData.median_price_m2 ?? undefined},
            avr_price: {price: lastMonthData.avg_price},
            offers_count: {count: lastMonthData.available_offers}
        };

        return {dateLabel, dataToRender};
    }

    const citiesData = getCitiesData();

    // Same guard as above: a failed BigData call leaves this empty, and citiesData[0] would dereference undefined.
    if (citiesData.length === 0) {
        return {dateLabel: undefined, dataToRender: null};
    }

    const date = parseISO(citiesData[0].date);
    const month = date && date.toLocaleString("pl-PL", {month: "long"});
    const dateLabel = month && `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

    const {allOffers, allOffersOld, generalAvgPrice, generalAvgM2Price, generalAvgPriceOld, generalAvgM2PriceOld} = calculateGeneralAvgPrices(citiesData);

    const dataToRender = {
        avr_price_m2: {price: generalAvgM2Price, percent: calculatePercent(generalAvgM2PriceOld, generalAvgM2Price)},
        // no median on the Poland-wide view - this branch averages the cities and a median cannot be derived that way
        median_price_m2: null,
        avr_price: {price: generalAvgPrice, percent: calculatePercent(generalAvgPriceOld, generalAvgPrice)},
        offers_count: {count: allOffers, percent: calculatePercent(allOffersOld, allOffers)}
    };

    return {dateLabel, dataToRender};
};
import {useSelector} from "react-redux";
import {parseISO} from "date-fns";

import {IRPStore} from "../../../app/rp_reducer";
import {ALL_ROOMS} from "../constants/rcn_rooms_filter";
import {calculateGeneralAvgPrices} from "./calculate_general_avg_prices";
import {getAvgPriceM2ForRooms} from "./get_avg_price_m2_for_rooms";
import {getCitiesData} from "./get_cities_data";
import {getLatestPriceReport} from "./get_latest_price_report";
import {calculatePercent} from "./percents_handling_helpers";

export const usePricesHeaderData = (region?: string) => {
    const pricesData = useSelector((state: IRPStore) => state.report.price.prices);

    if (region && pricesData) {
        const lastMonthData = getLatestPriceReport(pricesData);

        // A failed BigData call resolves to an empty array - without this guard the city view dereferences
        // undefined and the whole page dies in renderToString.
        if (!lastMonthData) {
            return {dateLabel: undefined, dataToRender: null};
        }

        const date = parseISO(lastMonthData.date);
        const month = date.toLocaleString("pl-PL", {month: "long"});
        const dateLabel = `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

        // No year-ago comparison is fetched for city/district views - none of their consumers (Hero/
        // Calculator) read percent or median_price_m2, only avr_price_m2.price.
        const dataToRender = {
            // Same source and same "all rooms" resolution as PricesDifferences's "Aktualna cena ofertowa"
            // card, so the two stay in sync by construction instead of by coincidence.
            avr_price_m2: {price: getAvgPriceM2ForRooms(lastMonthData, ALL_ROOMS)},
            median_price_m2: {price: lastMonthData.median_price_m2 ?? undefined},
            avr_price: {price: lastMonthData.avg_price},
            offers_count: {count: lastMonthData.available_offers}
        };

        return {dateLabel, dataToRender};
    }

    const citiesData = getCitiesData();

    // Same guard as above: a failed BigData call leaves this empty, and citiesData[0] would dereference undefined.
    if (citiesData.length === 0) {
        return {dateLabel: undefined, dataToRender: null};
    }

    const date = parseISO(citiesData[0].date);
    const month = date && date.toLocaleString("pl-PL", {month: "long"});
    const dateLabel = month && `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

    const {allOffers, allOffersOld, generalAvgPrice, generalAvgM2Price, generalAvgPriceOld, generalAvgM2PriceOld} = calculateGeneralAvgPrices(citiesData);

    const dataToRender = {
        avr_price_m2: {price: generalAvgM2Price, percent: calculatePercent(generalAvgM2PriceOld, generalAvgM2Price)},
        // no median on the Poland-wide view - this branch averages the cities and a median cannot be derived that way
        median_price_m2: null,
        avr_price: {price: generalAvgPrice, percent: calculatePercent(generalAvgPriceOld, generalAvgPrice)},
        offers_count: {count: allOffers, percent: calculatePercent(allOffersOld, allOffers)}
    };

    return {dateLabel, dataToRender};
};
